module.exports = __webpack_public_path__ + "img/3.400a65fa.jpg";